
export default {
    normal: '#e5e5e5',
    blue:   '#29cbd3',
    green:  'rgb(105,224,121)',
    red:    'rgb(222,38,111)',
    yellow: '#f8d800',
    orange: 'rgb(237,144,0)',
    purple: '#b782ed',
    dark:   '#454545'
}
